import { Injectable } from '@angular/core';
import {ActivatedRouteSnapshot, Resolve, Router} from '@angular/router';
import { Observable, } from 'rxjs';
import { WordpressService } from '../services/wordpress.service';
import {map} from 'rxjs/operators';

@Injectable()
export class JournalPostResolveGuard implements Resolve<any> {

  constructor(
    private wp: WordpressService,
    private router: Router
  ) {}
  resolve(route: ActivatedRouteSnapshot): Observable<any> {
    return this.wp.getJournalPost(route.params.post).pipe(map(res => {
      if (!res || res.length === 0) {
        // NOT FOUND
        this.router.navigate(['/journal']);
      }

      return res[0];
    }));
  }
}
